import type { AgentResponse, ReplaceAgentRequest, TransformedReplaceAgentBody } from '../api-types/agent';
import type { Agent } from '../types/agent';
import { transformCreateToolRequest, transformToolResponse } from './tool';

export const transformReplaceAgentRequest = (request: ReplaceAgentRequest): TransformedReplaceAgentBody => ({
  name: request.name,
  description: request.description,
  system_prompt: request.systemPrompt,
  dbid: request.dbId,
  project_id: request.projectId,
  organization_id: request.organizationId,
  is_private: request.isPrivate,
  tools: request.tools.map(transformCreateToolRequest),
  avatar_color: request.avatarColor,
  avatar_icon: request.avatarIcon,
});

export const transformAgentResponse = (response: AgentResponse): Agent => ({
  id: response.id,
  name: response.name,
  description: response.description,
  systemPrompt: response.system_prompt,
  dbId: response.dbid,
  projectId: response.project_id,
  organizationId: response.organization_id,
  createdBy: response.created_by,
  isPrivate: response.is_private,
  endpointLink: response.endpoint_link,
  tools: response.tools.map(transformToolResponse),
  avatarColor: response.avatar_color,
  avatarIcon: response.avatar_icon,
});

export const transformListAgentsResponse = (response: AgentResponse[]): Agent[] => {
  return response.map(transformAgentResponse);
};
